import React from 'react'
import TextOrNumberField from '../../DataEntryPage/Fields/TextOrNumberField'
import DateAndDateTime from '../../DataEntryPage/Fields/DateAndDateTime'
import { Autocomplete, TextField } from '@mui/material'
import FilePreviewField from '../../DataEntryPage/Fields/FilePreviewField'
import FileUploadField from '../../DataEntryPage/Fields/FileUploadField'
import BigTextField from '../../DataEntryPage/Fields/BigTextField'
import CurrencyField from '../../DataEntryPage/Fields/CurrencyField'
import { FIELD_TYPES } from '../../../utility/constants'
import moment from 'moment'
import { fileServices } from '../../../services/fileServices'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { getDefaultValueForField } from '../../DataEntryPage/utils/fieldUtil'

const getDefaultValue = (fieldTemplate) => {
  return fieldTemplate?.default_value?.values[0] || getDefaultValueForField(fieldTemplate)
}

const setDefaultValue = (defaultValue, setFieldTemplate) => {
  setFieldTemplate((fieldTemplate) => ({
    ...fieldTemplate,
    default_value: {
      is_same_value: false,
      values: [defaultValue],
    },
  }))
}

const DefaultValueField = ({ fieldTemplate, selectedListItems = [], setFieldTemplate }) => {
  const { user } = useAuthContext()

  const handleDefaultFileUpload = async (e) => {
    const file = e.target.files[0]
    const result = (await fileServices.uploadFile(user, file)).data
    const key = result?.filePath?.split('/')[1] || ''

    setDefaultValue(key, setFieldTemplate)
  }

  if (
    fieldTemplate.data_structure == FIELD_TYPES.NUMBER ||
    fieldTemplate.data_structure == FIELD_TYPES.TEXT
  ) {
    return (
      <TextOrNumberField
        label="Default Value"
        value={getDefaultValue(fieldTemplate)}
        onChange={(e) => setDefaultValue(e.target.value, setFieldTemplate)}
      />
    )
  } else if (
    fieldTemplate.data_structure == FIELD_TYPES.DATETIME ||
    fieldTemplate.data_structure == FIELD_TYPES.DATE
  ) {
    return (
      <DateAndDateTime
        value={moment(getDefaultValue(fieldTemplate))}
        label="Default Value"
        onChange={(e) => setDefaultValue(e?.format('YYYY-MM-DD HH:mm:ss'), setFieldTemplate)}
      />
    )
  } else if (fieldTemplate.data_structure == FIELD_TYPES.LIST) {
    return (
      <Autocomplete
        id="default-value-list-field"
        size="small"
        options={selectedListItems || []}
        value={selectedListItems.find((it) => getDefaultValue(fieldTemplate) == it.id + '') || null}
        getOptionLabel={(option) => option.value}
        label="Default Value"
        onChange={(_, v) => setDefaultValue(v?.id || null, setFieldTemplate)}
        renderInput={(params) => {
          return <TextField {...params} label="Default Value" />
        }}
      />
    )
  } else if (fieldTemplate.data_structure == FIELD_TYPES.LIST_MULTI) {
    return (
      <Autocomplete
        multiple
        id="default-value-list-multi-field"
        size="small"
        options={selectedListItems || []}
        value={
          selectedListItems.filter((it) =>
            String(getDefaultValue(fieldTemplate) || '')
              .split(',')
              .includes(String(it.id))
          ) || []
        }
        getOptionLabel={(option) => option.value}
        label="Default Value"
        onChange={(_, v) => {
          setDefaultValue(v?.map((it) => it.id).join(',') || null, setFieldTemplate)
        }}
        renderInput={(params) => {
          return <TextField {...params} label="Default Value" />
        }}
      />
    )
  } else if (fieldTemplate.data_structure == FIELD_TYPES.FILE) {
    return fieldTemplate?.default_value ? (
      <FilePreviewField
        value={getDefaultValue(fieldTemplate)}
        download={() => fileServices.downloadFile(user, fieldTemplate?.default_value)}
        clear={() => {
          setDefaultValue('', setFieldTemplate)
        }}
      />
    ) : (
      <FileUploadField placeholder="Upload Default File" onChange={handleDefaultFileUpload} />
    )
  } else if (fieldTemplate.data_structure == FIELD_TYPES.BIGTEXT) {
    return (
      <BigTextField
        placeholder="Default Value"
        value={getDefaultValue(fieldTemplate)}
        onChange={(e) => setDefaultValue(e.target.value, setFieldTemplate)}
      />
    )
  } else if (fieldTemplate.data_structure == FIELD_TYPES.CURRENCY) {
    return (
      <CurrencyField
        label="Default Value"
        value={getDefaultValue(fieldTemplate)}
        onChange={(e) => setDefaultValue(e.floatValue, setFieldTemplate)}
      />
    )
  } else {
    return (
      <TextField
        type="text"
        value={getDefaultValue(fieldTemplate)}
        fullWidth
        size="small"
        variant="outlined"
        color="primary"
        onChange={(e) => setDefaultValue(e.target.value, setFieldTemplate)}
        label={`Default Value`}
      />
    )
  }
}

export default DefaultValueField
